import { clearWorkflows } from '../utils/workflowUtils';
import { useEffect } from 'react';

export const useRegisterWorkflowConfigs = (registerCallback: Function) => {
    useEffect(() => {
        clearWorkflows();

        registerCallback();
    }, []);
};
